var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BigNumber } from "@ethersproject/bignumber";
import { useContext } from "react";
import { VaultLiquidityMiningMap, } from "../constants/constants";
import { isEVMChain } from "../utils/chains";
import { SubgraphDataContext } from "./subgraphDataContext";
var getLMPoolKey = function (vault) { return "lm_" + vault.replace(/-/g, ""); };
export var liquidityMiningPoolGraphql = function (version, chain) {
    return version === "v1" && isEVMChain(chain)
        ? Object.keys(VaultLiquidityMiningMap.lm).reduce(function (acc, curr) {
            return acc +
                ("\n      " + getLMPoolKey(curr) + ": vaultLiquidityMiningPool(id:\"" + VaultLiquidityMiningMap.lm[curr].toLowerCase() + "\") {\n              numDepositors\n              totalSupply\n              totalRewardClaimed\n            }\n    ");
        }, "")
        : "";
};
export var resolveLiquidityMiningPoolsSubgraphResponse = function (responses) {
    return Object.fromEntries(Object.keys(VaultLiquidityMiningMap.lm).map(function (vaultOption) {
        var data = responses["v1"]
            ? responses["v1"][getLMPoolKey(vaultOption)]
            : undefined;
        return [
            vaultOption,
            data
                ? __assign(__assign({}, data), { totalSupply: BigNumber.from(data.totalSupply), totalRewardClaimed: BigNumber.from(data.totalRewardClaimed) }) : undefined,
        ];
    }));
};
var useLiquidityMiningPools = function () {
    var context = useContext(SubgraphDataContext);
    return {
        stakingPools: context.vaultSubgraphData.stakingPools.lm,
        loading: context.vaultSubgraphData.loading,
    };
};
export default useLiquidityMiningPools;
//# sourceMappingURL=useLiquidityMiningPools.js.map